import React from 'react';
export function NorthvilleFAQHeader() {
  return <h2 className="text-4xl md:text-5xl text-ink text-center mb-16" data-id="element-2601">
      Frequently Asked Questions
    </h2>;
}